module.exports = __webpack_public_path__ + "img/icons BFr_12.7fa6a2a0.svg";